import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

// components
import AppCard from 'src/components/AppCard'
import AppCardHeader from 'src/components/card/AppCardHeader'
import AppDetails from 'src/components/details/category-details/AppDetails'
import AppModalConfirmation from 'src/components/modal/AppModalConfirmation'

// helpers
import Axios from 'src/helpers/axios'
import useToastMessage from 'src/helpers/toast-message'

const CategoryDetails = () => {
  const navigate = useNavigate()
  const params = useParams()
  const { id } = params
  const { showError } = useToastMessage();

  const [categoryDetails, setCategoryDetails] = useState('')

  const [showConfirmDelete, setShowConfirmDelete] = useState({ show: false, item: {} })

  const handleCardHeaderButton = () => {
    navigate(`/products/category/edit/${id}`)
    window.location.reload();
  }

  useEffect(() => {
    fetchCategoryDetails()
  }, [id]);

  const fetchCategoryDetails = () => {
    Axios({
      method: "get",
      url: `/api/ecommerce/v1/categories/id/${id}`,
    })
      .then(({ data }) => {
        setCategoryDetails(data)
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const handleDeleteConfirmation = (item) => {
    Axios({
      method: "delete",
      url: `/api/ecommerce/v1/categories/${item.id}`,
    })
      .then(({ data }) => {
        setShowConfirmDelete({ show: false, item: {} })
        navigate(`/products/category/list`)
      })
      .catch((err) => {
        console.error(err);
        const message = err?.response?.data?.message?.replace(/-/g, " ").replace(err?.response?.data?.message.charAt(0), err?.response?.data?.message.charAt(0).toUpperCase())
        showError(message)
        setShowConfirmDelete({ show: false, item: {} })
      });
  }

  return (
    <>
      {showConfirmDelete.show && (
        <AppModalConfirmation
          confirmationType='delete-item'
          itemName='category'
          itemDetails={showConfirmDelete.item}
          showModal={showConfirmDelete}
          setShowModal={setShowConfirmDelete}
          handleConfirmation={handleDeleteConfirmation}
        />
      )}
      <AppCard
      className='mt-4 mb-4'
      headerTitle={
        <AppCardHeader
          id={id}
          headerTitle={<h4>Category Details</h4>}
          headerButton="Edit"
          handleCardHeaderButton={handleCardHeaderButton}
          headerDeleteButton={true}
          setShowConfirmDelete={setShowConfirmDelete}
        />
      }
      bodyContent={
        <AppDetails
          categoryDetails={categoryDetails}
        />
      }
    />
    </>

  )
}

export default CategoryDetails
